import { FormControl, FormLabel, Stack } from '@chakra-ui/react';
import { Field } from 'formik';
import BooleanToggle from 'components/forms/new/formikFormFields/BooleanToggle';
import {
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

const TeamsEnabledField = ({ darkMode, values, setFieldValue }) => (
    <FormControl sx={{ margin: '0 !important' }}>
        <Stack
            direction="row"
            alignItems="center"
            spacing={stackSpacing}
            sx={stackStyling()}>
            <FormLabel sx={formLabelStyling(darkMode, true)}>
                Teams Enabled
            </FormLabel>
            <Field
                name="teamsEnabled"
                component={BooleanToggle}
                isChecked={values?.teamsEnabled ?? false}
                onChange={(value) => setFieldValue('teamsEnabled', value)}
            />
        </Stack>
    </FormControl>
);

export default TeamsEnabledField;
